import { Slider } from './core/slider';
new Slider(jQuery).run();
